import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} 在线播放`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-semibold text-background-50">
          {video.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-center bg-gradient-to-t from-foreground-950/70 to-transparent pb-2 pt-8 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
            <i className="ri-play-fill text-lg" />
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {video.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {video.genres.join(" · ")}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
            {video.typeName}
          </span>
          <span>{video.year}</span>
        </div>
      </div>
    </Link>
  );
}